document.addEventListener('DOMContentLoaded', function() {
            const articleContent = document.getElementById('article-content');
            const tocList = document.getElementById('toc-list');
            const headings = articleContent.querySelectorAll('h2');
            
            // Generate TOC from headings
            if (headings.length > 0) {
                tocList.innerHTML = '';
                
                headings.forEach((heading, index) => {
                    // Add ID to heading if it doesn't have one
                    if (!heading.id) {
                        heading.id = `section-${index + 1}`;
                    }
                    
                    const listItem = document.createElement('li');
                    listItem.className = 'toc__item';
                    
                    const link = document.createElement('a');
                    link.href = `#${heading.id}`;
                    link.className = 'toc__link';
                    link.textContent = heading.textContent;
                    
                    // Add special styling for h3 (sub-items)
                    if (heading.tagName.toLowerCase() === 'h3') {
                        link.style.paddingLeft = '36px';
                        link.style.fontSize = '13px';
                        link.style.color = '#888';
                    }
                    
                    // Add CTA class to last item
                    // if (index === headings.length - 1) {
                    //     link.classList.add('toc__link--cta');
                    //     link.style.paddingLeft = '12px';
                    //     link.style.fontSize = '14px';
                    // }
                    
                    listItem.appendChild(link);
                    tocList.appendChild(listItem);
                });
            }
            
            // Smooth scroll to section
            const tocLinks = tocList.querySelectorAll('.toc__link');
            tocLinks.forEach(link => {
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    const targetId = this.getAttribute('href').substring(1);
                    const targetElement = document.getElementById(targetId);
                    
                    if (targetElement) {
                        const offsetTop = targetElement.offsetTop - 80;
                        window.scrollTo({
                            top: offsetTop,
                            behavior: 'smooth'
                        });
                    }
                });
            });
            
            // Highlight active section on scroll
            const observerOptions = {
                root: null,
                rootMargin: '-100px 0px -66%',
                threshold: 0
            };
            
            const observerCallback = (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const id = entry.target.id;
                        tocLinks.forEach(link => {
                            link.classList.remove('active');
                            if (link.getAttribute('href') === `#${id}`) {
                                link.classList.add('active');
                            }
                        });
                    }
                });
            };
            
            const observer = new IntersectionObserver(observerCallback, observerOptions);
            
            headings.forEach(heading => {
                observer.observe(heading);
            });
        });